import {
  ColumnDefinition,
  SortDirection,
  SortSelector,
  SortState,
} from '@publicisgroupe/p-os-components';

export const constructSortState = <Tdata, TField>(
  selector: SortSelector<Tdata, TField>,
  columnDefinitions: ColumnDefinition<Tdata, TField, any>[],
  defaultSortState: SortState<Tdata, TField>,
  currentSortState?: SortState<Tdata, TField>
) => {
  // returns undefined, when sorting not possible
  if (currentSortState === undefined) {
    return {};
  }

  const column = columnDefinitions.find((x) => x.accessor === selector.accessor);

  // column not sortable
  if (!column?.sortable) {
    return {};
  }

  // returns defaultState
  if (
    selector.accessor !== defaultSortState.accessor &&
    currentSortState.accessor === selector.accessor &&
    currentSortState.direction === SortDirection.Descending
  ) {
    return defaultSortState;
  }

  return {
    name: selector.name,
    accessor: selector.accessor,
    selector: selector.selector,
    direction:
      currentSortState.direction === SortDirection.Ascending
        ? SortDirection.Descending
        : SortDirection.Ascending,
  } as SortState<Tdata, TField>;
};
